import React from 'react';
import { Image } from '../Image';
import { centsToDollars } from '../../lib/util';
import styles from '../../styles/lineItem.module.scss';
import { CartItemID, GiftCardDelivery } from '../../types';
import { GIFT_CARD_IMAGES } from '../../views/GiftCard/GiftCardImages.constant';
import RemoveLineItemButton from '../RemoveLineItemButton';
import GiftCardInformation from './GiftCardInformation';
import { getFiGrowthBook } from '../../lib/growthbook';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

interface GiftCardLineItemProps {
  id: CartItemID;
  productName: string;
  productPriceInCents: number;
  giftCardDelivery: GiftCardDelivery;
  removeCartItem?: () => void;
}

export default function GiftCardCartItem({
  productName,
  productPriceInCents,
  giftCardDelivery,
  removeCartItem,
}: GiftCardLineItemProps) {
  const showEcomCartTest = getFiGrowthBook().getFeatureValue('ecom-cart-test', false);
  const { t } = useTranslation();
  return (
    <div className={styles.lineItem}>
      {removeCartItem && !showEcomCartTest && (
        <div className={styles.removeButtonRow}>
          <RemoveLineItemButton onClick={removeCartItem} />
        </div>
      )}
      <div className={styles.itemRow}>
        <div className={classNames(styles.lineItemImage, styles.giftCardImage)}>
          <Image image={GIFT_CARD_IMAGES[0]} desiredWidth={100} />
        </div>
        <div className={styles.lineItemBody}>
          <div className={styles.lineItemPriceRows}>
            <div className={styles.lineItemPriceRow}>
              <div className={styles.lineItemDetails}>
                <div className={styles.productName}>{t('fi_gift_card')}</div>
                <GiftCardInformation delivery={giftCardDelivery} />
              </div>

              <div className={styles.lineItemPrice}>{t('price', { price: centsToDollars(productPriceInCents) })}</div>
            </div>
          </div>
          {removeCartItem && showEcomCartTest && (
            <div className={styles.removeButton} onClick={removeCartItem}>
              {t('remove')}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
